<template>
    <div>
        {{ trans('activities.events.task.approved') }} <b>{{ item.subject.code }}</b>
    </div>
</template>
<script setup>
import { trans } from '@/mixins/i18n.js';

defineProps({ item: Object });
</script>
